module.exports = __webpack_public_path__ + "img/eco-btn-swiper.802b78af.png";